// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b2hG","name":"styles_name__DfDdK","phone":"styles_phone__2q0-W"};